module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bots-num-bottom borde-dashed"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "bnb-contain aligner",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "textos",
    attrs: {
      "id": "bnb-contain",
      "tabindex": "0"
    }
  }, [_vm._l((_vm.numeroBotones), function(item, index) {
    return (index + 1 === _vm.contenidoActual) ? _vm._t('cont' + index) : _vm._e()
  }), _vm._v(" "), (!_vm.finContenidos && (_vm.contenidoActual > 0)) ? _c('button', {
    attrs: {
      "aria-label": "Volver a la lista anterior"
    },
    on: {
      "click": function($event) {
        _vm.backMenu()
      }
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "bnb-buttons"
  }, [_c('ul', {
    staticClass: "unstyled-list"
  }, _vm._l((_vm.numeroBotones), function(item, index) {
    return _c('li', [_c('button', {
      staticClass: "hvr-grow",
      class: _vm.botsColorsClass(index),
      attrs: {
        "id": 'bnb-bots' + index,
        "aria-label": 'Botón ' + (index + 1) + ' ' + (_vm.botones[index].visto ? 'visto' : 'no visto')
      },
      on: {
        "click": function($event) {
          _vm.showCont(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(index + 1) + "\n            ")])])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4160dc1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BotsNumberBottom.vue
// module id = 965
// module chunks = 1